<template>
  <div v-loading="loading" class="alarmClass">
    <div :style="contentStyle">
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <!-- <el-col :span="12">
              <el-form-item label="老人姓名" prop="name">

                <el-input
                clearable
                 :disabled="model==='view'" v-model="form.name"
                placeholder="自理情况"
                maxlength="100"
              ></el-input>
              </el-form-item>
            </el-col> -->
          <!-- <el-col :span="12">
            <el-form-item label="床位号" prop="bedNumber">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.bedNumber"
                placeholder="请输入床位号"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="登记时间" prop="registrationTime">
              <!-- <el-input
                clearable
                 :disabled="model==='view'" v-model="form.registrationTime"
                placeholder="登记时间"
                maxlength="100"
              ></el-input> -->

              <el-date-picker
                style="width: 100%;"
                value-format="yyyy-MM-dd HH:mm:ss"
                 :disabled="model==='view'" v-model="form.registrationTime"
                type="date"
                placeholder="请选择登记时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="登记人" prop="registranter">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.registranter"
                placeholder="请输入登记人"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="体检医院" prop="examinationHospital">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.examinationHospital"
                placeholder="请输入体检医院"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="体检时间" prop="examinationTime">
              <!-- <el-input
                clearable
                 :disabled="model==='view'" v-model="form.examinationTime"
                placeholder="体检时间"
                maxlength="100"
              ></el-input> -->

              <el-date-picker
                style="width: 100%;"
                value-format="yyyy-MM-dd HH:mm:ss"
                 :disabled="model==='view'" v-model="form.examinationTime"
                type="date"
                placeholder="请选择体检时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="体检结果" prop="examinationResult">
              <el-input
              type="textarea"
                clearable
                 :disabled="model==='view'" v-model="form.examinationResult"
                placeholder="请输入体检结果"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!-- <el-form-item label="体检图片" prop="examinationPictureUrlList">
              <vUpload
                :message="'提示：只能上传jgp/png文件，且不大于5MB，数量最多1张'"
                :types="['jpg', 'png']"
                :max="5242880"
                :limit="1"
                 :disabled="model==='view'"
                :fileList.sync="form.examinationPictureUrlList"
              ></vUpload>
            </el-form-item> -->
            <el-form-item label="体检附件" prop="examinationPictureUrlList">
              <VUploadDrag :disabled="model=='view'" :max="10 * 1024 * 1024" :limit="10" :fileList.sync="form.examinationPictureUrlList" />
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
    </div>
  </div>
</template>
  <script>
import vUpload from "../components/mutil-upload.vue"
import VUploadDrag from '@/views/components/v-upload-drag';
  import { saveMedicalTestInfo,getPhysicalDetail
} from '../api/serveItemManage';
import { getStore } from '@/util/store';
export default {
    components: {vUpload, VUploadDrag},
  // components: {},
  model: {
    prop: 'form',
    event: 'change',
  },
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      projectList: [],
      form: {
        name: '',
      },
      contentStyle: '',
      formRules: {
        name: [{ required: true, message: '物料名称不能为空', trigger: 'blur' }],
        nursinghomeId: [{ required: false, message: '项目名称不能为空', trigger: 'change' }],
      },
      matetialList: [],
    };
  },
  created() {
    this.initData();
  },
  mounted() {
    this.calcHeight();
  },
  watch: {},
  methods: {
    calcHeight() {
      let bodyHight = document.body.clientHeight;
      let contentHeight = bodyHight - 340;
      this.contentStyle =
        'max-height:' + contentHeight + 'px; overflow-y: scroll;overflow-x: hidden;';
    },

    async initData() {
      if(getStore({name:'elderId'})){
        getPhysicalDetail({elderlyId: getStore({name:'elderId'})}).then((res)=>{
          this.form = res.data;
        });
      }
      if (this.model == 'add') {
      } else {
      }
    },
    saveRecord(cb) {
      let result = false;
      this.$refs['formRef'].validate((valid) => {
        console.log('子', valid);
        result = valid;
        if(result){
            saveMedicalTestInfo({elderlyId:getStore({name:'elderId'}),...this.form}).then((res)=>{
              this.$message.success('操作成功！');
              this.$emit('success', this.form);
            if(cb)cb();
            });
          // saveMedicalTestInfo(this.form).then((res)=>{
          //   this.$message.success('操作成功！',res);
          //   // setStore({
          //   //   name: 'elderId',
          //   //   content: res.data
          //   // })
          // });
        }
      });
      return result;
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
  <style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
.title {
  text-align: center;
  line-height: 50px;
  font-size: 20px;
}
</style>
